/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tis_Claims_Non_Medical_TitleInputs */

const en_tis_claims_non_medical_title = /** @type {(inputs: Tis_Claims_Non_Medical_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Form Non-Medical`)
};

const fr_tis_claims_non_medical_title = /** @type {(inputs: Tis_Claims_Non_Medical_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de réclamation non médicale`)
};

/**
* | output |
* | --- |
* | "Claim Form Non-Medical" |
*
* @param {Tis_Claims_Non_Medical_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const tis_claims_non_medical_title = /** @type {((inputs?: Tis_Claims_Non_Medical_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tis_Claims_Non_Medical_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tis_claims_non_medical_title(inputs)
	return fr_tis_claims_non_medical_title(inputs)
});